<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="ts" setup></script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
@media (prefers-color-scheme: dark) {
  .el-select-dropdown {
    background: #23272f !important;
    border-color: #444 !important;
  }
  .el-select-dropdown__item {
    color: #eee !important;
    background: #23272f !important;
  }
  .el-select-dropdown__item.selected,
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #fff !important;
    background: #409eff !important;
  }
  .el-select-dropdown__empty {
    color: #eee !important;
    background: #23272f !important;
  }
}
</style>
